import './style.css';
// Only needed if using built-in animations
import 'notivue/animations.css';

/* Import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VueQueryPlugin } from '@tanstack/vue-query';
import Vueform from '@vueform/vueform';
import { Amplify } from 'aws-amplify';
import { createNotivue } from 'notivue';
import { createApp } from 'vue';

import vueformConfig from '../vueform.config';
import App from './App.vue';
import { dvvAuthConfig } from './aws-exports';
import { i18n } from './i18n/i18n';
import { loadIcons } from './icons/fontAwesome';
import { roleDirective } from './plugins/roleDirective';
import { queryClient } from './queryClient';
import router from './router';
import { initSentry } from './sentry';
import { restoreWoningNetAuthFromStorage } from './services/woningNetSsoService';

/* Add icons to the library */
loadIcons();

const app = createApp(App);

const notivue = createNotivue({
  position: 'top-right',
  notifications: {
    global: {
      // Duration should allow a screenreader to read the message aloud before the notification disappears
      duration: 8000,
    },
  },
});

app.use(Vueform, vueformConfig);
app.use(roleDirective);

// Configure Amplify with DVV auth by default (magic link authentication)
Amplify.configure(dvvAuthConfig);
// Restore WoningNet SSO as current provider when persisted (survives full page reload)
restoreWoningNetAuthFromStorage();

app.component('FontAwesomeIcon', FontAwesomeIcon);
app.use(router);
initSentry(app);
app.use(VueQueryPlugin, { queryClient });
app.use(i18n);
app.use(notivue);
app.mount('#app');
